import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import {
  isCommunityAdmin,
  isCommunityModerator,
} from "@circle-react/helpers/communityMemberHelpers";
import type { ReactElement } from "react";

import { KEYBOARD_SHORTCUTS_DATA } from "./constants";
import { ShortcutDisplay } from "./ShortcutDisplay";

interface ShortcutsListProps {
  renderCategory: (category: string) => ReactElement;
}

export const ShortcutsList = ({ renderCategory }: ShortcutsListProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const isModerator = isCommunityModerator(currentCommunityMember);

  return (
    <div className="space-y-5">
      {KEYBOARD_SHORTCUTS_DATA.map(data => (
        <div key={data.category} className="flex flex-col">
          {renderCategory(data.category)}
          {data.shortcuts.map(shortcut => (
            <ShortcutDisplay
              key={shortcut.name}
              shortcut={shortcut}
              isAdmin={isAdmin}
              isModerator={isModerator}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
